import { ReactElement } from "react";
import { Box, Divider, List, ListItem, Typography } from "@mui/material";

const HelpSettings = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant="h5">Frequently Asked Questions</Typography>

            <Typography variant="h6" id="billing">Billing & Payments</Typography>
            <QuestionAnswer
                question={"How does Statrat validate my payment method?"}
                answer={
                    <Typography>
                        Statrat places a small temporary charge of $0.50 - $1.00 on your card to
                        validate your payment method. This charge is not posted and is only
                        used for verification purposes.
                    </Typography>
                }
            />
            <QuestionAnswer
                question={"When does Statrat charge me?"}
                answer={
                    <Typography>
                        Statrat follows a pay-as-you-go model. You will be charged once your
                        outstanding ad spend reaches the $150 payment threshold.
                    </Typography>
                }
            />
            <QuestionAnswer
                question={"How does Statrat determine pricing?"}
                answer={
                    <>
                    <Typography>Statrat charges based on:</Typography>
                    <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <Typography>
                                The number of clicks your advertisement receives.
                            </Typography>
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <Typography>
                                The number of impressions (times your ad is shown).
                            </Typography>
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <Typography>
                                The location of your ad (e.g., Home page vs. Explore page).
                            </Typography>
                        </ListItem>
                    </List>
                    <Typography>
                        We continuously monitor and adjust our pricing to ensure you get
                        the best value for your ad spend.
                    </Typography>
                    </>
                }
            />

            <Divider />
            <Typography variant="h6" id="ad">Ad Performance & Approval</Typography>
            <QuestionAnswer
                question={"How can I track my ad performance?"}
                answer={
                    <Typography>
                        You can view real-time insights on your ad performance, including impressions,
                        clicks, and conversions, directly in your Statrat advertiser dashboard.
                    </Typography>
                }
            />
            <QuestionAnswer
                question={"What happens if my ad gets disapproved?"}
                answer={
                    <Typography>
                        If your ad doesn't meet our advertising guidelines, it will be returned to you
                        for edits, along with an explanation of the required changes.
                        There is no notification for this, but you can view the status and required
                        changes in your dashboard.
                    </Typography>
                }
            />

            <Divider />
            <Typography variant="h6" id="support">Account & Support</Typography>
            <QuestionAnswer
                question={"How do I update my payment method?"}
                answer={
                    <Typography>
                        You can update your payment details at any time in the Billing section of
                        your dashboard.
                    </Typography>
                }
            />
            <QuestionAnswer
                question={"How do I pause or stop an ad campaign?"}
                answer={
                    <Typography>
                        You can stop any active campaign from your advertiser dashboard.
                        Once an ad is approved it cannot be edited, a new ad must instead be made and re-approved.
                    </Typography>
                }
            />
            <QuestionAnswer
                question={"Who can I contact for help?"}
                answer={
                    <Typography>
                        If you need assistance with the dashboard, ad creation, or any other inquiries,
                        please contact us at {<a href="mailto:info@statrat.ca">info@statrat.ca</a>}.
                    </Typography>
                }
            />
        </Box>
    )
}

const QuestionAnswer = ({ question, answer }: { question: string, answer: ReactElement<any, any> }) => {
    return (
        <Box display="flex" flexDirection="column">
            <Typography component="div"><Box sx={{ fontWeight: 'bold' }}>{question}</Box></Typography>
            {answer}
        </Box>
    )
}

export default HelpSettings;
